export const GET_COOKIES = "@@COOKIES/GET";
export const PUT_COOKIES = "@@COOKIES/PUT";

export const actionCreators = {
    getCookies: () => ({
        type: GET_COOKIES, 
    }),
    putCookies: (payload) => ({
        type: PUT_COOKIES,
        payload
    }),
}